import React, { useEffect, useState } from "react";
import { makeStyles } from '@mui/styles';
import Option from "./Option";
import { generateColors } from "./Colors";
import { chunk } from "lodash";

const useStyles = makeStyles(theme => ({
  optionsWrapper: {
    marginTop: theme.spacing(1),
    marginLeft: "auto",
    marginBottom: theme.spacing(2),
    display: "flex",
    justifyContent: "flex-end",
    flexWrap: "wrap",
    width: "100%",
    maxWidth: ({ noOfOptions }) => (noOfOptions === 4 ? 400 : 500)
  }
}));

function OptionsList({ options, chatWindowRef }) {
  const [activePage, setActivePage] = useState(0);

  let pages = chunk(options, 5);

  useEffect(() => {
    chatWindowRef.current.scrollToBottom();
  }, [activePage]);

  // If there is more than 1 page then add the "More options" button
  if (pages.length > 1) {
    pages[activePage].push({
      type: "moreOptions",
      text: "More options",
      clickAction: () => setActivePage(activePage ? 0 : 1)
    });
  }

  let colors = generateColors(pages[activePage].length);

  const noOfOptions = pages[activePage].length;

  const classes = useStyles({ noOfOptions });

  return (
    <div className={classes.optionsWrapper}>
      {pages[activePage].map((option, i) => (
        <Option key={i} color={colors[i]} noOfOptions={noOfOptions} {...option} />
      ))}
    </div>
  );
}

export default OptionsList;
